import { GridConfiguration } from "../../teiasoft-bucket/teiasoft-grid-odata/teiasoft-grid-odata.component";
import { ItemsSection } from "./documentTemplate";

export class UserConfiguration {
    gridsConfigurations?: GridConfiguration[];
    theme?: string;
    quotationTemplate?: {
        itemSections: ItemsSection[]
    }
}